import * as types from "./types";
import { getPersistedDataAsObj, persist, remove } from "./storage";
import {
  safeGetItemFromLocalStorage,
  safeRemoveItemFromLocalStorage
} from "./utils";

// there's a bunch of old ugly legacy code to handle some
//  things that fraction is storing outside of redux
const legacyStorage = {
  __updateLanguageOnLogin: "updateLanguageOnLogin"
};
const parseLegacyStorage = value => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};
const loadedLegacyStorage = Object.keys(legacyStorage).reduce((acc, key) => {
  const result = safeGetItemFromLocalStorage(legacyStorage[key]);
  if (result !== undefined && result !== null && result !== "undefined") {
    acc[key] = { value: parseLegacyStorage(result), expires: false };
  }
  return acc;
}, {});

const deleteLegacyStorage = key => {
  const legacyKey = legacyStorage[key];
  if (legacyKey) {
    safeRemoveItemFromLocalStorage(legacyKey);
  }
};

const persistedState = getPersistedDataAsObj();

const handleAdd = (state, key, transient, data) => {
  if (!data) {
    // This shouldn't happen. The action creator should always give us a data object
    return state;
  }
  if (!transient) {
    persist(key, data);
  }
  return {
    ...state,
    [key]: data
  };
};

const handleDelete = (state, key) => {
  const finalData = { ...state };
  delete finalData[key];
  remove(key);
  deleteLegacyStorage(key);
  return finalData;
};

export default (
  state = { ...loadedLegacyStorage, ...persistedState },
  action
) => {
  switch (action.type) {
    case types.STORAGE_SET_KEY:
      return handleAdd(state, action.key, action.transient, action.data);
    case types.STORAGE_DELETE_KEY:
      return handleDelete(state, action.key);
    default:
      return state;
  }
};
